// eslint-disable-next-line no-undef
const userAgent = typeof navigator !== "undefined" && navigator.userAgent;

export const IS_IOS_SAFARI = (
  userAgent &&
  userAgent.match(/(iPod|iPhone|iPad)/) &&
  userAgent.match(/AppleWebKit/)
)

export const init = () => {
  if (IS_IOS_SAFARI && userAgent.match(/OS 8/)) {
    document.documentElement.className += ' ios8-safari' // eslint-disable-line no-undef
  }
}



// WEBPACK FOOTER //
// ./client/utility/browser.js